import { Box, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const FormTitle = () => {
	const { translate } = useLocales();

	return (
		<Stack alignItems='center' direction='row' sx={{ mb: 5 }}>
			<Box sx={{ flexGrow: 1 }}>
				<Typography gutterBottom variant='h4'>
					{translate("Cambia tu contraseña")}
				</Typography>
				<Typography sx={{ color: "text.secondary" }}>
					{translate("Por seguridad, necesitamos que cambies tu contraseña.")}
				</Typography>
			</Box>
		</Stack>
	);
};

export default FormTitle;
